/**
 * Central dwell-time configuration.
 *
 * Station dwells are keyed by stable station-complex ids (network.json
 * `station.id`, e.g. `station:de:05111:18235_Parent`), so platforms and
 * direction-specific stop points of the same complex share one value.
 */

export const DEFAULT_DWELL_S = 25;

/** Station-specific dwell overrides (seconds). */
export const DWELL_OVERRIDES: Record<string, number> = {
  'station:de:05111:18235_Parent': 35, // Düsseldorf Hbf
  'station:de:05111:18036_Parent': 35, // Heinrich-Heine-Allee
};

export function dwellForStation(stationId: string | null | undefined): number {
  if (stationId && DWELL_OVERRIDES[stationId] != null) return DWELL_OVERRIDES[stationId];
  return DEFAULT_DWELL_S;
}
